import React, { useCallback, useState } from "react"
import { AnimatePresence } from "framer-motion"
import { Plus } from "lucide-react"
import { useTranslation } from "react-i18next"
import { fmtMoney } from "../../utils/grid/common"
import PriceEditModal from "../PriceEditModal"

const SHOW_COPY = false
// true — рядом с ценой появляется маленький плюс для добавления ещё одной цены
const SHOW_ADD_PRICE = false

const PriceCell = ({
  prices = [],
  typeId,
  typeName,
  routeName,
  baseId,
  template,
  buildNewUrl,
  buildEditUrl,
  onDelete,
  onSavePrice,
  onCreatePrice,
  valuteOptions = [],
  transferTypeOptions = [],
  busyIds,
}) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const [addOpen, setAddOpen] = useState(false)
  const close = useCallback(() => setOpen(false), [])
  const closeAdd = useCallback(() => setAddOpen(false), [])
  const typeParam = typeId || undefined

  const addModal = (
    <AnimatePresence>
      {addOpen && (
        <PriceEditModal
          mode="add"
          title={t("admin.add_price", { defaultValue: "Добавить цену" })}
          subtitle={[routeName, typeName].filter(Boolean).join(" · ")}
          baseId={baseId}
          typeId={typeId}
          template={template}
          valuteOptions={valuteOptions}
          transferTypeOptions={transferTypeOptions}
          onCreate={onCreatePrice}
          onClose={closeAdd}
        />
      )}
    </AnimatePresence>
  )

  if (!prices.length) {
    return (
      <>
        <button
          type="button"
          onClick={() => setAddOpen(true)}
          title={t("admin.add_price_for_type", { defaultValue: "Добавить цену для этого типа" })}
          className="mx-auto flex h-9 w-9 items-center justify-center rounded-full border border-dashed border-app-content-faint/40 text-app-content-faint hover:border-brand-main hover:text-brand-main hover:bg-brand-main/5 transition-colors"
        >
          <Plus className="w-4 h-4" />
        </button>
        {addModal}
      </>
    )
  }

  const min = Math.min(...prices.map((p) => p.adult))
  const currency = prices[0].currency
  const many = prices.length > 1

  return (
    <>
      <div className="flex items-center justify-center gap-1">
        <button
          type="button"
          onClick={() => setOpen(true)}
          className={`flex flex-col items-center rounded-input px-3 py-1.5 transition-colors hover:bg-brand-main/5 ${
            open ? "bg-brand-main/10" : ""
          }`}
        >
          <span className="font-semibold text-app-content leading-tight">
            {many && (
              <span className="mr-1 text-xs font-normal text-text-muted">
                {t("admin.from", { defaultValue: "от" })}
              </span>
            )}
            {fmtMoney(min)}
          </span>
          <span className="text-xs text-text-muted">
            {currency}
            {many && ` · ${prices.length}`}
          </span>
        </button>

        {SHOW_ADD_PRICE && (
          <button
            type="button"
            onClick={() => setAddOpen(true)}
            title={t("admin.add_price", { defaultValue: "Добавить цену" })}
            className="flex h-7 w-7 items-center justify-center rounded-full border border-dashed border-app-content-faint/40 text-app-content-faint hover:border-brand-main hover:text-brand-main hover:bg-brand-main/5 transition-colors"
          >
            <Plus className="w-3.5 h-3.5" />
          </button>
        )}
      </div>

      <AnimatePresence>
        {open && (
          <PriceEditModal
            mode="edit"
            title={routeName}
            subtitle={typeName}
            prices={prices}
            transferTypeOptions={transferTypeOptions}
            valuteOptions={valuteOptions}
            buildEditUrl={buildEditUrl}
            buildNewUrl={buildNewUrl}
            baseId={baseId}
            typeParam={typeParam}
            onSave={onSavePrice}
            onDelete={onDelete}
            busyIds={busyIds}
            onClose={close}
            showCopy={SHOW_COPY}
          />
        )}
      </AnimatePresence>

      {addModal}
    </>
  )
}

export default PriceCell
